import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("max_agenda_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function setAuthToken(token) {
    if (token) localStorage.setItem("max_agenda_token", token);
    else localStorage.removeItem("max_agenda_token");
}

export function getAuthToken() {
    return localStorage.getItem("max_agenda_token");
}

export function formatApiError(err, fallback = "Errore. Riprova.") {
    const detail = err?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    }
    return err?.message || fallback;
}

export default api;
